import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n  fragment Checkout on Checkout {\n    token\n    id\n    totalPrice {\n      ...Price\n    }\n    subtotalPrice {\n      ...Price\n    }\n    billingAddress {\n      ...Address\n    }\n    shippingAddress {\n      ...Address\n    }\n    email\n    availableShippingMethods {\n      ...ShippingMethod\n    }\n    shippingMethod {\n      ...ShippingMethod\n    }\n    shippingPrice {\n      ...Price\n    }\n    lines {\n      ...CheckoutLine\n    }\n    isShippingRequired\n    discount {\n      currency\n      amount\n    }\n    discountName\n    translatedDiscountName\n    voucherCode\n    note\n    deliveryNote\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  fragment CheckoutLine on CheckoutLine {\n    id\n    selectedProductAttributes\n    quantity\n    totalPrice {\n      ...Price\n    }\n    variant {\n      ...ProductVariant\n    }\n    productAttributes {\n      attribute {\n        id\n        name\n        translation(languageCode: $languageCode) {\n          name\n        }\n        values {\n          name\n          translation(languageCode: $languageCode) {\n            name\n          }\n        }\n      }\n      values\n    }\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  fragment ShippingMethod on ShippingMethod {\n    id\n    name\n    translation(languageCode: $languageCode) {\n      name\n    }\n    price {\n      currency\n      amount\n    }\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  fragment ProductVariant on ProductVariant {\n    id\n    name\n    translation(languageCode: $languageCode) {\n      name\n    }\n    sku\n    quantityAvailable\n    isAvailable\n    pricing {\n      onSale\n      priceUndiscounted {\n        ...Price\n      }\n      price {\n        ...Price\n      }\n    }\n    attributes {\n      attribute {\n        id\n        name\n        translation(languageCode: $languageCode) {\n          name\n        }\n      }\n      values {\n        id\n        name\n        translation(languageCode: $languageCode) {\n          name\n        }\n        value: name\n      }\n    }\n    product {\n      id\n      name\n      translation(languageCode: $languageCode) {\n        name\n      }\n      category {\n        id\n        name\n        translation(languageCode: $languageCode) {\n          name\n        }\n      }\n      thumbnail {\n        url\n        alt\n      }\n      thumbnail2x: thumbnail(size: 510) {\n        url\n      }\n      productType {\n        isShippingRequired\n      }\n    }\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  fragment Address on Address {\n    id\n    firstName\n    lastName\n    companyName\n    streetAddress1\n    streetAddress2\n    city\n    postalCode\n    country {\n      code\n      country\n    }\n    countryArea\n    phone\n    isDefaultBillingAddress\n    isDefaultShippingAddress\n    vatNumber\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  fragment Price on TaxedMoney {\n    gross {\n      amount\n      currency\n    }\n    net {\n      amount\n      currency\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from "graphql-tag";
export var checkoutPriceFragment = gql(_templateObject());
export var checkoutAddressFragment = gql(_templateObject2());
export var checkoutProductVariantFragment = gql(_templateObject3(), checkoutPriceFragment);
export var checkoutShippingMethodFragment = gql(_templateObject4());
export var checkoutLineFragment = gql(_templateObject5(), checkoutPriceFragment, checkoutProductVariantFragment);
export var checkoutFragment = gql(_templateObject6(), checkoutLineFragment, checkoutAddressFragment, checkoutPriceFragment, checkoutShippingMethodFragment);